import { useQuery } from "@tanstack/react-query";
import { getParameter, refreshRemoteConfig } from "@/services/firebase/remoteConfig";
import { ARTIST_DM_FLAG, ARTIST_FANS_FLAG, ARTIST_FLAGS_OFF, ArtistFlags, toArtistFlags } from "@/lib/artistFlags";

async function readFlags(): Promise<ArtistFlags> {
  // The CMS does not activate Remote Config anywhere else; fetch once so we read the published template, not defaults.
  await refreshRemoteConfig().catch(() => undefined);
  const read = (key: string) =>
    getParameter(key)
      .then((p) => p?.value ?? false)
      .catch(() => false);
  const [fans, dm] = await Promise.all([read(ARTIST_FANS_FLAG), read(ARTIST_DM_FLAG)]);
  return toArtistFlags(fans, dm);
}

/** RC artist_fans_enabled / artist_dm_enabled for the CMS; missing or failed reads count as off. */
export function useArtistFlags(): ArtistFlags & { loading: boolean } {
  const query = useQuery({
    queryKey: ["remote-config", "artist-flags"],
    queryFn: readFlags,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return { ...(query.data ?? ARTIST_FLAGS_OFF), loading: query.isPending };
}
